import moment from 'moment'

const DateFormatted = ({ date }) => {
  return (
    <div>{moment(date).format('DD/MM/YYYY')}</div>
  )
}

export default DateFormatted